import classes from '../AdminView.module.css'
import { Table } from '@mui/material'
import { TableHead } from '@mui/material'
import { TableCell } from '@mui/material'
import { TableBody } from '@mui/material'
import { TableRow } from '@mui/material'
import { TablePagination } from '@mui/material'
import { TableContainer, Paper } from '@mui/material'
import React from 'react'
import AdminControllButtons from '../../UI/Admin/AdminControllButtons/AdminControllButtons'
import EmptyData from '../../UI/Admin/EmpyData/EmptyData'
import TableTh from '../../UI/Table/TableTh/TableTh'

const HowItWas = (props) => {
    const { howItWasList, handleRemove, handleEdit } = props

    const rows = [
        {
            key: "Title",
            text: 'Title',
            searchByValue: ""
        },
        {
            key: 'photo',
            text: "Photo",
            searchByValue: ""
        },
        {
            key: '',
            text: "",
            searchByValue: ""
        }
    ]

    return (
        <div className={classes.main}>
                <TableContainer component={Paper} className={classes.table}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {rows.map(item => (
                                    <TableTh
                                        key={item.key}
                                        text={item.text}
                                    />
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {howItWasList.map(item => (
                                <TableRow key={item._id}>
                                    <TableCell width={"20%"}>{item.title}</TableCell>
                                    <TableCell width={"70%"}>
                                        <img src={item.backgroundImg} alt="poster" className={classes.imgPreview}/>
                                    </TableCell>
                                    <TableCell width={120}>
                                        <AdminControllButtons
                                            item={item}
                                            onRemove={handleRemove}
                                            onEdit={handleEdit}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {howItWasList.length === 0 && <EmptyData/>}
        </div>
    )
}

export default HowItWas